import { CalculatedValue } from '../../../model/calculated-value';
import { ClientEvaluatedFactor } from '../../../model/client-model/client-evaluated-factor';
import { ClientParameter } from '../../../model/client-model/client-parameter';
import { OutputResource } from '../../../model/emission-inventory-tree';
import { AccountingScope } from '../../../services/backend/model/tree';
import { KeyMap } from '../../../services/climate-engine/ccc-algorithm/key-map';

export interface EmissionInventoryCccData {
  energyIntensity: ClientEvaluatedFactor;
  id: string;
  translationKey: string;
  operationGrowthPerCapita: ClientParameter;
  operations: ClientParameter;
  scope: AccountingScope;
  outputs: EmissionInventoryOutput[];
  resources: EmissionInventoryResourceData[];
  isNew: boolean;
}
export interface EmissionInventoryCccDataWithEnergyAndEmission extends EmissionInventoryCccData {
  energy: number;
  emissionsByScope: {
    scope1: number;
    scope2: number;
    scope3: number;
  };
  totalEmissions: number;
  costs: KeyMap<number>;
}

export interface EmissionInventoryOutput {
  resource: OutputResource;
  unit: string;
  primary?: boolean;
  isNew?: boolean;
  workToResource: ClientEvaluatedFactor;
}

export interface EmissionInventoryResourceData {
  proportion: ClientParameter;
  resource: EmissionInventoryResource;
}

interface EmissionInventoryResource {
  emissionFactor: ClientParameter | CalculatedValue;
  id: string;
  nativeUnit: string;
  translationKey: string;
  conversionFactor?: ClientParameter;
}

export const FULL_PROPORTION = {
  hasScaling: false,
  id: '',
  isNew: false,
  max: undefined,
  min: undefined,
  name: '',
  unit: 'percentage',
  value: 100,
  inventoryId: undefined,
};
